import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeNode } from '../../services/mapping.service';

const PREVIEW_LIMIT = 5;

@Component({
  selector: 'app-tree-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tree-preview.component.html',
  styleUrls: ['./tree-preview.component.scss']
})
export class TreePreviewComponent {
  @Input() nodes: TreeNode[] = [];
  @Input() depth = 0;

  showAll = false;

  get isEmpty(): boolean {
    return this.depth === 0 && this.nodes.length === 0;
  }

  get hasChildren(): boolean {
    return this.nodes.some(n => n.children && n.children.length > 0);
  }

  get visibleNodes(): TreeNode[] {
    if (this.depth > 0) return this.nodes;
    return this.showAll ? this.nodes : this.nodes.slice(0, PREVIEW_LIMIT);
  }

  get showExpandButton(): boolean {
    if (this.depth > 0) return false;
    return this.nodes.length > PREVIEW_LIMIT || this.hasChildren;
  }

  get hiddenCount(): number {
    return Math.max(0, this.nodes.length - PREVIEW_LIMIT);
  }
}
